<template>
    <v-navigation-drawer
        :value="siderRightVisibility"
        app
        fixed
        right
    >
        <v-container>
            Country in charge
            <countries></countries>
        </v-container>

    </v-navigation-drawer>
</template>

<script>

    import { mapState } from "vuex";
    import countries from '../../modules/countries/index'

    export default {
        name: "SiderRight",

        components: {
            countries
        },

        modules: {
            countries
        },

        computed: {
            ...mapState([
                "siderRightVisibility"
            ])
        },

        data: () => ({}),
    }
</script>
